var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1478 5.46078L7.14779 14.4608C7.09555 14.5131 7.03351 14.5546 6.96523 14.5829C6.89694 14.6112 6.82375 14.6258 6.74982 14.6258C6.6759 14.6258 6.60271 14.6112 6.53442 14.5829C6.46613 14.5546 6.4041 14.5131 6.35186 14.4608L2.41436 10.5233C2.30881 10.4177 2.24951 10.2746 2.24951 10.1253C2.24951 9.97605 2.30881 9.83289 2.41436 9.72734C2.5199 9.6218 2.66306 9.5625 2.81232 9.5625C2.96159 9.5625 3.10475 9.6218 3.21029 9.72734L6.74982 13.2676L15.3519 4.66484C15.4574 4.5593 15.6006 4.5 15.7498 4.5C15.8991 4.5 16.0422 4.5593 16.1478 4.66484C16.2533 4.77039 16.3126 4.91355 16.3126 5.06281C16.3126 5.21208 16.2533 5.35523 16.1478 5.46078Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRegular);
export default __webpack_public_path__ + "static/media/CheckRegular.e180af053bf9ab5cb929e72986a24143.svg";
export { ForwardRef as ReactComponent };